import type { FaireProductEntity } from "../../entity_types/product";

export const p_ztd8jrk2b3: FaireProductEntity = {
  token: "p_ztd8jrk2b3",
  type: "product",
  name: "Wanderlux Minnesota Northwoods Glow 6.5 Ounce Soy Candle",
  brandName: "Wanderlux Candles",
  imageUrl:
    "https://cdn.faire.com/fastly/1d960509cb60c62341daafde53ef17a81785d63b6494eb24519a03d26982c010.jpeg",
  priceDollars: 13.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/694f681aba0c7541f966cc1d0221ad3dd00df99e26e1b5ca2d751f534fe9791f.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
